module.exports = __webpack_public_path__ + "img/other.be6a1348.png";